import styled from "styled-components";

export const ShipMonitoringCardItem = styled.li`
  position: relative;
  overflow: hidden;
  display: grid;
  height: 100%;
  padding: 20px 0 0;
  background: ${(props) => props.theme.colors.shipMonitorBackgroud};
  border-radius: 6px;
  grid-template-rows: 120px auto;
`;

export const ShipMonitoringCard = styled.div`
  display: flex;
  padding: 20px;
  justify-content: center;
  flex-direction: column;
  gap: 20px;

  & + div {
    border-top: 1px solid ${(props) => props.theme.colors.shipMonitorBorder};
  }
`;

export const ShipCardContent = styled.div`
  display: relative;
  display: flex;
  z-index: 10;

  div {
    display: flex;
    width: 50%;
    padding-bottom: 12px;
    color: ${(props) => props.theme.colors.white100};
    font-size: 2.2rem;
    font-weight: 500;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 4px;

    span {
      font-size: 1.2rem;
    }
  }
`;

export const ShipCardGraphicBox = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  gap: 2px;
`;

export const ShipCardTitle = styled.h5`
  color: ${(props) => props.theme.colors.white100};
  font-size: 1.6rem;
  font-weight: 500;
`;

export const ShipCardGraphic = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  z-index: 5;

  div {
    display: flex;
    width: 100%;
    margin-top: 28px;
  }

  .icon_direction {
    position: absolute;
  }

  svg {
    width: 80%;
    height: 80%;
  }
`;
